 <template>
  <div class="burger-menu cell shrink" @click="$emit('toggle')">
    <i class="bi" :class="isOpen ? 'bi-x-lg' : 'bi-list'"></i>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BurgerMenu',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  }
})
</script>

<style lang="scss" scoped>
.burger-menu {
  display: flex;
  align-items: center;
  padding: 0 1rem;
  cursor: pointer;
  height: 3.75rem;
  min-height: 3.75rem;

  i {
    font-size: 1.5rem;
    color: $petrol;
  }
}
</style> 